export const getToken = async () => {
  try {
    const response = await fetch(`api/token/get-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.text();
      console.error('Error fetching token:', error);
      return null; // Return null or handle the error appropriately
    }

    const token = await response.json();
    return token; // Return the fetched token for use elsewhere
  } catch (error) {
    console.error('Error calling API:', error);
    throw new Error(error);
  }
};
